<template>
  <div class="hb-content">
    <div class="card" v-for="(item,i) in list" :key="i">
      <div class="img-box">
        <el-tooltip popper-class="show-popper__arrow" effect="dark" placement="top" content="进入直播页">
          <div>
            <img :src="item.img" class="card-img" alt="" @click="openPage(item)" />
            <div class="play-btn" v-if="item.videoUrl"></div>
          </div>
        </el-tooltip>
        
        <div class="mask" v-if="!item.videoUrl">
          <el-button class="ylbtn" @click="$refs.fileModel.open(item)">预览</el-button>
          <el-button class="xzbtn" @click="downloadFile(item)">下载</el-button>
        </div>
      </div>
      <div class="downbtn" v-if="item.videoUrl" @click="downloadFile(item)">下载相关课件</div>
      <div class="title">{{item.title}}</div>
      <div class="desc">{{item.summary}}</div>
    </div>
    <fileModel ref="fileModel"></fileModel>
  </div>
</template>

<script>
import fileModel from "./fileModel";
export default {
  props: {
    list:null,
  },
  data: () => ({
    fileList:[],
  }),
  components:{
    fileModel
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 打开链接
    openPage(item) {
      if(item.videoUrl){
        window.open(item.videoUrl)
      }
    },
    // 下载单个文件
    downloadFile(item) {
      const list = [
        {
          type: 3,
          articleId: item.id,
        }
      ];
      this.$tools.daochu('/master/information/downloadFile',{list},'put');
    },
  }
};
</script>

<style lang="scss" scoped>
@import "./trainingCenter";
</style>
